import "core-js/modules/es6.regexp.replace";
import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import toQueryString from '../../lib/toQueryString';

function formatMarkers(markers) {
  var index = 0;
  return markers.map(function (_ref) {
    var positions = _ref.positions,
        styles = _ref.styles;
    return positions.map(function (_ref2) {
      var _styles$color, _styles$label;

      var lat = _ref2.lat,
          lng = _ref2.lng;
      index += 1;

      if (styles === null || styles === void 0 ? void 0 : styles.icon) {
        return "url-".concat(encodeURIComponent(styles.icon), "(").concat(lng, ",").concat(lat, ")");
      }

      var color = (styles === null || styles === void 0 ? void 0 : (_styles$color = styles.color) === null || _styles$color === void 0 ? void 0 : _styles$color.replace('#', '')) || '000';
      var label = (styles === null || styles === void 0 ? void 0 : (_styles$label = styles.label) === null || _styles$label === void 0 ? void 0 : _styles$label.toLowerCase()) || index;
      return "".concat((styles === null || styles === void 0 ? void 0 : styles.size) || 'pin-s', "-").concat(label || '', "+").concat(color || '', "(").concat(lng, ",").concat(lat, ")");
    }).join(',');
  }).join(',');
}

export default function MapBoxImage(_ref3) {
  var accessToken = _ref3.accessToken,
      alt = _ref3.alt,
      bearing = _ref3.bearing,
      height = _ref3.height,
      lat = _ref3.lat,
      lng = _ref3.lng,
      markers = _ref3.markers,
      pitch = _ref3.pitch,
      retina = _ref3.retina,
      width = _ref3.width,
      zoom = _ref3.zoom;
  var host = 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/static';
  var query = toQueryString({
    access_token: accessToken
  });
  var overlay = markers.length && formatMarkers(markers);
  return React.createElement(Image, {
    alt: alt,
    src: "".concat(host).concat(overlay ? "/".concat(overlay) : '', "/").concat(lng, ",").concat(lat, ",").concat(zoom, ",").concat(bearing, ",").concat(pitch, "/").concat(width, "x").concat(height).concat(retina ? '@2x' : '').concat(query ? "?".concat(query) : '')
  });
}
MapBoxImage.propTypes = {
  /** MapBox access token */
  accessToken: PropTypes.string,

  /** Native alt attribute */
  alt: PropTypes.string.isRequired,

  /** Rotates the map around its center (0 to 360) */
  bearing: PropTypes.number,

  /** Height of the produced image */
  height: PropTypes.number,

  /** Center point latitude */
  lat: PropTypes.number.isRequired,

  /** Center point longitude */
  lng: PropTypes.number.isRequired,

  /** Array of markers */
  markers: PropTypes.arrayOf(PropTypes.shape({
    positions: PropTypes.arrayOf(PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired
    })),
    styles: PropTypes.shape({
      color: PropTypes.string,

      /** Single alphanumeric character a through z or 0 through 99, may also be a valid Maki icon */
      label: PropTypes.string,
      size: PropTypes.oneOf(['pin-s', 'pin-l'])
    })
  })),

  /** Tilts the map, producing a perspective effect (0 to 60) */
  pitch: PropTypes.number,

  /** Produces a high density image @2x */
  retina: PropTypes.bool,

  /** Width of the produced image */
  width: PropTypes.number,

  /** Zoom level (0 to 22) */
  zoom: PropTypes.number
};
MapBoxImage.defaultProps = {
  accessToken: undefined,
  bearing: 0,
  height: 300,
  markers: [],
  pitch: 0,
  retina: true,
  width: 600,
  zoom: 10
};